import { Component, Input, Output, EventEmitter } from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-registration-help',
  imports: [
    TranslatePipe
  ],
  templateUrl: './registration-help.component.html',
  styleUrl: './registration-help.component.css'
})
export class RegistrationHelpComponent {
  @Input() title: string;
  @Input() subHeading: string;
  @Input() message: string;
  @Input() helpItems: string[];
  @Input() footer: string;
  @Input() supportMail: string;
  @Output() onClose: EventEmitter<void> = new EventEmitter();

  close() {
    this.onClose.emit();
  }

}
